import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '../views/Login.vue'
import AdminLayout from '../layout/AdminLayout.vue'
import Overview from '../views/Overview.vue'
import Users from '../views/Users.vue'
import FortuneOps from '../views/FortuneOps.vue'
import UserProfile360 from '../views/UserProfile360.vue'
import ReportsTickets from '../views/ReportsTickets.vue'
import OrdersCompensations from '../views/OrdersCompensations.vue'
import AuditLogs from '../views/AuditLogs.vue'
import { getToken } from '../utils/auth'

const routes = [
  { path: '/login', component: Login },
  {
    path: '/',
    component: AdminLayout,
    children: [
      { path: '', redirect: '/overview' },
      { path: '/overview', component: Overview },
      { path: '/users', component: Users },
      { path: '/user-360', component: UserProfile360 },
      { path: '/reports-tickets', component: ReportsTickets },
      { path: '/orders-compensations', component: OrdersCompensations },
      { path: '/audit-logs', component: AuditLogs },
      { path: '/fortune-ops', component: FortuneOps }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') return next()
  if (!getToken()) return next('/login')
  next()
})

export default router
